define('app/views/templates/helpers/editUrlFinder',['Handlebars','moment'], function ( Handlebars,moment ){
    function editUrlFinder(obj ) {
        var urlMap = {
            Spa: '#/spaBooking/package/Location'+obj.LocationId+'/Edit///'+moment(obj.StartDate, "YYYY-MM-DDHHmmss").format('YYYY-MM-DD')+'/'+obj.FolioItemId,
            Hotel:  '',
            Club: '',
            PMSPayment: '',
            SPAPayment: '',
            Dining: '#/dining/show/'+obj.Location+'/'+moment(obj.StartDate, "YYYY-MM-DDHHmmss").format('YYYY-MM-DD')+'/'+moment(obj.StartDate, "YYYY-MM-DDHHmmss").format('HH:mm')+'/'+obj.RateDetails+'/'+obj.ItemClass+'/'+obj.FolioId
        }

        return urlMap[obj.Category] || '#/summary/show/';
        
    }
    
    Handlebars.registerHelper( 'editUrlFinder', editUrlFinder );
    return editUrlFinder;
});
        

